// extracted by mini-css-extract-plugin
module.exports = {"root":"HardwareExtraOptions_root__2jjG_"};